import React from 'react';

class ProgressMeter extends React.Component {
  render() {
    const { current, total } = this.props;
    const shown = Math.min(current + 1, total);
    const pct = Math.max(0, Math.min(100, Math.round((shown / total) * 100)));
    return (
      <div className="w-full mb-6">
        <div className="flex items-center justify-between mb-2">
          <div className="text-succession-muted text-sm">Step {shown} of {total}</div>
          <div className="text-succession-muted text-sm">{pct}%</div>
        </div>
        <div className="h-2 w-full bg-succession-border rounded-full overflow-hidden">
          <div className="h-full bg-succession-primary transition-all" style={{ width: pct + '%' }} />
        </div>
      </div>
    );
  }
}

export default ProgressMeter;


